module.exports = __webpack_public_path__ + "8c67ec5fe8f9bfe1d46d511ef39e8c29.png";